// extracted by mini-css-extract-plugin
export default {"body":"loading_body__cxtIy","container":"loading_container__px5o1","scale":"loading_scale__MjS5I","loader":"loading_loader__mAdx2","rotate":"loading_rotate__WVH5Y"};